import { SymptomsPage } from "./symptoms";

export const Symptoms = SymptomsPage;
